import { useQuery } from '@tanstack/react-query';
import { get } from 'api/base';
import type { VisitReasonResponse } from 'types/anamnesis';

export function useVisitReasons(medatixxId?: string | null) {
  return useQuery({
    queryKey: ['visitReasons', medatixxId],
    queryFn: async () => {
      const data = await get('getVisitReasons', undefined, { medatixxId });
      return data as VisitReasonResponse;
    },
    enabled: !!medatixxId,
  });
}
